require('../../modules/es6.reflect.define-property');
module.exports = require('../../modules/_core').Reflect.defineProperty;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/define-property.js
// module id = 1434
// module chunks = 2